//
import Headers from '@/models/Headers'
//import { Headers } from '@/components/reusable_components/prototypes'

//
export default new Headers('WhProductHeaders',
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'código interno',
        value: 'internal_code',
        width: '15%',
    },
    {
        text: 'alias',
        value: 'alias_name',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'código de proveedor',
        value: 'last_provider_code_provider',
        width: '15%',
    },
    {
        text: 'inventariable',
        value: 'wh_item_is_inventoriable',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'reenvasable',
        value: 'is_repackaged',
        align: 'center',
        format: 'boolean',
    },
)
